import { DigitShortcutCurrency } from '../types/currency'
import { DigitShortcuts } from './pipes'

export const TranslatedCurrencyDigitInputs: DigitShortcuts = {
  thousands: 'shortcutsPipe.thousands',
  millions: 'shortcutsPipe.millions',
  billions: 'shortcutsPipe.billions',
  default: '',
}

export const TranslatedCurrencyYearInputs: DigitShortcutCurrency = {
  first: 'shortcutsPipe.year',                  // ex. (czech): 1 rok
  secondAndOn: 'shortcutsPipe.yearsTwoOrMore',  // ex. (czech): 2 roky
  fifthAndOn: 'shortcutsPipe.yearsFiveOrMore',  // ex. (czech): 5 let
  default: ''
}